import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import SectionTitle from "../Common/SectionTitle";
import PortfolioContainer from "./ContainerComponent/PortfolioContainer";
import PortfolioDetail from "./ContainerComponent/PortfolioDetail";

const Portfolio = ({ portfolios, categories }) => {
    const [activeCategory, setActiveCategory] = useState("All");
    const [filteredPortfolios, setFilteredPortfolios] = useState(null);
    const [detailPortfolio, setDetailPortfolio] = useState(false);
    const [detailContent, setDetailContent] = useState({});

    useEffect(() => {
        setFilteredPortfolios(
            activeCategory.toLowerCase() === "all"
                ? portfolios
                : portfolios.filter((x) => x.type === activeCategory)
        );
    }, [portfolios, activeCategory]);

    const openDetail = (id) => () => {
        setDetailPortfolio(true);
        const portfolioData = portfolios.find((x) => x.id === id);
        setDetailContent(portfolioData);
    };

    const closeDetail = () => {
        setDetailPortfolio(false);
        setDetailContent(null);
    };

    if (detailPortfolio)
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <PortfolioDetail content={detailContent} closeDetail={closeDetail} />
            </motion.div>
        );

    return (
        <div>
            <SectionTitle SectionName="Projects" />

            {/* Category filter tabs */}
            {categories && categories.length > 1 && (
                <div className="flex flex-wrap gap-2 mt-6">
                    {categories.map((category) => {
                        const isActive = activeCategory === category;
                        return (
                            <button
                                key={category}
                                onClick={() => setActiveCategory(category)}
                                className="transition-all duration-200"
                                style={{
                                    fontSize: "11px",
                                    fontWeight: 500,
                                    letterSpacing: "0.05em",
                                    padding: "5px 14px",
                                    borderRadius: "6px",
                                    border: isActive
                                        ? "1px solid rgba(200,151,42,0.4)"
                                        : "1px solid rgba(255,255,255,0.1)",
                                    background: isActive
                                        ? "rgba(200,151,42,0.12)"
                                        : "rgba(255,255,255,0.04)",
                                    color: isActive
                                        ? "#C8972A"
                                        : "rgba(255,255,255,0.45)",
                                    cursor: "pointer",
                                }}
                            >
                                {category}
                            </button>
                        );
                    })}
                </div>
            )}

            {/* Portfolio grid */}
            {filteredPortfolios && filteredPortfolios.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 mt-6">
                    {filteredPortfolios.map((portfolio) => (
                        <PortfolioContainer
                            key={portfolio.id}
                            PortfolioData={portfolio}
                            openDetail={openDetail}
                        />
                    ))}
                </div>
            ) : (
                <div
                    className="mt-6 rounded-xl flex items-center justify-center"
                    style={{
                        height: "160px",
                        background: "rgba(255,255,255,0.02)",
                        border: "1px solid rgba(255,255,255,0.06)",
                    }}
                >
                    <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.25)" }}>
                        {filteredPortfolios === null ? "Loading projects..." : "No projects found."}
                    </p>
                </div>
            )}
        </div>
    );
};

export default Portfolio;
